import { render, staticRenderFns } from "./specialPriceApplyTask.vue?vue&type=template&id=bf4006a2&scoped=true"
import script from "./specialPriceApplyTask.vue?vue&type=script&lang=js"
export * from "./specialPriceApplyTask.vue?vue&type=script&lang=js"
import style0 from "./specialPriceApplyTask.vue?vue&type=style&index=0&id=bf4006a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4006a2",
  null
  
)

export default component.exports